import { render } from "./CContactMessage.vue?vue&type=template&id=4af0256f"
import script from "./CContactMessage.vue?vue&type=script&lang=js"
export * from "./CContactMessage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__